import { IDepartment } from '../types';

// General constants
export const NOT_SELECTED: string = 'not-selected';
export const OLD_QUESTIONNAIRE_SAMPLE: string = 'СТАРЫЙ_ОБРАЗЕЦ_АНКЕТЫ';

// Departments IDs
export const MANAGEMENT_DEPARTMENT: string = 'managing-department';
export const ACADEMY: string = 'academy';
export const JURIDICAL_DEPARTMENT: string = 'juridical-department';
export const PUBLISHING_DEPARTMENT: string = 'publishing-department';
export const MARKETING_DEPARTMENT: string = 'marketing-department';
export const ACCOUNTING_DEPARTMENT: string = 'accounting-department';
export const BROADCAST_DEPARTMENT: string = 'broadcast-department';
export const CENTRAL_DEPARTMENT: string = 'central-department';
export const INSPECTION_DEPARTMENT: string = 'inspection-department';
export const DIPLOMACY_DEPARTMENT: string = 'diplomacy-department';
export const DOCUMENTATION_DEPARTMENT: string = 'documentation-department';
export const CHARITY_DEPARTMENT: string = 'charity-department';
export const IT_DEPARTMENT: string = 'it-department';

// Tab IDs
export const ALL = 'all';
export const UNASSIGN = 'unassign';
export const ASSIGN = 'assign';
export const COUNCIL = 'council';

// Departments meta info
export const departments: Array<IDepartment> = [
  {
    id: NOT_SELECTED,
    label: 'Не выбрано',
  },
  {
    id: MANAGEMENT_DEPARTMENT,
    label: 'Отдел Управления',
    email: 'president@gold-race.org',
    head: 'Александр Воронюк',
  },
  {
    id: CENTRAL_DEPARTMENT,
    label: 'Центральный Отдел',
    email: 'tanya-do70@mail.ru',
    head: 'Татьяна Мальцева',
  },
  {
    id: PUBLISHING_DEPARTMENT,
    label: 'Отдел Издательства',
    email: 'mamamarimarina@gmail.com',
    head: 'Марина Горкавенко',
  },
  {
    id: ACADEMY,
    label: 'Академия',
    email: 'dianka.kupaeva@mail.ru',
    head: 'Диана Купаева',
  },
  {
    id: MARKETING_DEPARTMENT,
    label: 'Отдел Маркетинга',
    email: 'marketing@gold-race.org',
    head: 'Екатерина Захарова-Жукова',
  },
  {
    id: BROADCAST_DEPARTMENT,
    label: 'Отдел Вещания',
    email: 'broadcast@gold-race.org',
    head: 'Павел Горохов',
  },
  {
    id: ACCOUNTING_DEPARTMENT,
    label: 'Отдел Бухгалтерии',
    email: 'egor-off@bk.ru',
    head: 'Егор Горшков',
  },
  {
    id: JURIDICAL_DEPARTMENT,
    label: 'Юридический Отдел',
    email: 'president@gold-race.org',
    head: 'Александр Воронюк',
  },
  {
    id: DIPLOMACY_DEPARTMENT,
    label: 'Отдел Внешних Отношений',
    email: 'gold.race.ru@gmail.com',
    head: 'Анатолий Вознесенский',
  },
  {
    id: DOCUMENTATION_DEPARTMENT,
    label: 'Отдел Документации',
    email: 'info@gold-race.org',
    head: 'Валентина Борискина',
  },
  {
    id: INSPECTION_DEPARTMENT,
    label: 'Ревизионный Отдел',
    email: 'exg@list.ru',
    head: 'Хажак Еремян',
  },
  {
    id: CHARITY_DEPARTMENT,
    label: 'Благотворительный Отдел',
    email: 'sawkina.o@yandex.ru',
    head: 'Ольга Савкина',
  },
  {
    id: IT_DEPARTMENT,
    label: 'Отдел Информационных Технологий',
    email: 'it@gold-race.org',
    head: 'Роман Мосолов',
  },
];
